<template>
  <Block
    type="form"
    icon="block-form"
    :id="id"
    :collections="collections"
    :show-controls="showControls"
    :searchable="searchable"
  >
    <h2 class="ag-block__title mt-1">Lead Gen Form</h2>
  </Block>
</template>

<script>
import Block from "./Block.vue"

export default {
  components: {
    Block
  },
  props: {
    id: {
      type: Number,
      required: true
    },
    searchable: {
      type: Boolean,
      required: true
    },
    collections: {
      type: Array,
      default: () => []
    },
    showControls: {
      type: Boolean,
      default: false
    }
  }
}
</script>
